
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import moment from 'moment';

const MaterialGrid = ({ material }) => {
    const { t } = useTranslation();

    const employeesState = useSelector(state => state.employees);

    if (!material) return null;

    let odometer = material.odometer;
    let odometer_date = material.odometer_date;
    let odometer_employee = '';
    let odometer_employee_id = material.odometer_employee_id;

    if (material.material_events.length > 0) {
        const sortedEvMat = material.material_events.sort((a, b) => {
            if (a.date > b.date) return -1;
            if (a.date < b.date) return 1;
            if (a.odometer > b.odometer) return -1;
            if (a.odometer < b.odometer) return 1;
            return 0;
        });
        if (!odometer_date || (moment(sortedEvMat[0].date).isAfter(moment(odometer_date)))) {
            odometer = sortedEvMat[0].odometer;
            odometer_date = sortedEvMat[0].date;
            odometer_employee_id = sortedEvMat[0].employee_id;
        }
        if (moment(sortedEvMat[0].date).isSame(moment(odometer_date)) && sortedEvMat[0].odometer > odometer) {
            odometer = sortedEvMat[0].odometer;
            odometer_date = sortedEvMat[0].date;
            odometer_employee_id = sortedEvMat[0].employee_id;
        }
    }

    if (odometer_employee_id) {
        const odo_emp = employeesState.all.find(e => e.id === odometer_employee_id);
        odometer_employee = `${odo_emp?.firstname || ''} ${odo_emp?.lastname.toUpperCase() || ''}`;
    }

    return <>
        <div className='employee-grid' style={{margin: '32px 64px 32px 64px'}}>
            {material ? (
                <>
                    <div className="section-title with-icon"> Famille <br /> <div className="section-value">{material?.family || '-'}</div> </div>
                    <div className="section-title">Immatriculation<br /> <div className="section-value">{material?.registration || '-'}</div></div>
                    <div className="section-title">Type<br />  <div className="section-value">{material?.type || '-'}</div></div>
                    <div className="section-title">Numéro de série<br />  <div className="section-value">{material?.serial_number || '-'}</div></div>
                    <div className="section-title">Marque<div className="section-value">{material?.brand || '-'}</div></div>
                    <div className="section-title">Numéro interne<br /> <div className="section-value">{material?.numero || '-'}</div></div>
                    <div className="section-title">Modèle<br /> <div className="section-value">{material?.model || '-'}</div></div>
                    <div className="section-title">Parc/Loueur<br /> <div className="section-value">{material?.parc || '-'}</div></div>
                </>
            ) : null }
        </div>
        <hr style={{ marginLeft: '48px', marginRight: '48px' }} />
        <div className='employee-grid'>
            {material ? (
                <>
                    <div className="section-title with-icon"> Compteur<br /> <div className="section-value">
                        {odometer} {material?.odometer_unit}<br />
                        {odometer_date && moment(odometer_date).format('DD/MM/YYYY')}<br />
                        {odometer_employee}
                    </div> </div>
                    <div className="section-title">Dotation<br /> <div className="section-value">
                        {material?.employee_linked?.firstname} {material?.employee_linked?.lastname.toUpperCase()}
                    </div></div><div />
                </>
            ) : (
                null
            )}
        </div>
    </>;
};

export default MaterialGrid;